/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IUserState {
  forgotPass: string;
  previousForgotPass: string;
  userResetOption: string;
  resetOtp: string;
}

const initialState: IUserState = {
  forgotPass: '',
  previousForgotPass: '',
  userResetOption: '',
  resetOtp: ''
};

export const forgotPasswordSlice = createSlice({
  name: 'forgotPass',
  initialState,
  reducers: {
    setForgotPass: (state: IUserState, action: PayloadAction<string>) => {
      const { payload } = action;
      state.forgotPass = payload;
    },
    setPreviousForgotPass: (state: IUserState, action: PayloadAction<string>) => {
      const { payload } = action;
      state.previousForgotPass = payload;
    },
    setUserResetOption: (state: IUserState, action: PayloadAction<string>) => {
      const { payload } = action;
      state.userResetOption = payload;
    },
    setResetOtp: (state: IUserState, action: PayloadAction<string>) => {
      const { payload } = action;
      state.resetOtp = payload;
    }
  }
});

const { actions, reducer } = forgotPasswordSlice;
export const { setForgotPass, setPreviousForgotPass, setUserResetOption, setResetOtp } = actions;
export default reducer;
